import InternalVMware from "@/features/Dashboard/Icons/InternalVmware";
import InternalOpennebula from "@/features/Dashboard/Icons/InternalOpennebula";
import InternalOpennebulaKubernetes from "@/features/Dashboard/Icons/InternalOpennebulaKubernetes";

export default {
    InternalVMware,
    InternalOpennebula,
    InternalOpennebulaKubernetes
} as any